import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateSocialMediaDisclosureQueries } from '../Social/useSocialMediaDisclosure';
import { invalidateSocialMediaSignatureQueries } from '../Templates/useTemplate';

export function useAccountSocialMediaSignatureTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({
			templateId,
			impersonationContext,
		}: {
			templateId: string | null;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IAccount>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'account/preferences/socialMediaSignatureTemplate',
					impersonationContext,
				}),
				'PUT',
				{ templateId }
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['template'] });
			// Post previews resolve the account disclaimer through these keys, which don't share the 'template' prefix.
			invalidateSocialMediaSignatureQueries();
			invalidateSocialMediaDisclosureQueries();
			onSuccess?.();
		},
		onError,
	});
}
